import { ConceptDetail } from './../model/concept-detail';
import { Vars } from '../model/vars';
import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { BaseReportService } from '../../shared/_utils/services/base-report-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { Observable } from 'rxjs/Observable';
import { tap} from 'rxjs/operators';
import { ExecutingUnit } from '../entities/executingUnit';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { Hhelpdesk } from '../entities/hhelpdesk';
import { CostCenter } from '../entities/costCenter';
import { FiscalYear } from '../entities/fiscalYear'; 
import { PayrollType } from '../entities/payroll-type';
import { EmployeeType } from '../entities/employeeType';


interface ExtraSearchFields {
  object?: any;
  fiscalYear?: FiscalYear,
  executingUnit?: ExecutingUnit,
  payrollType?: PayrollType,
  employeeType?: EmployeeType,
  monthIni?: Hhelpdesk,
  monthFin?: Hhelpdesk 
}

@Injectable()
export class ReportConceptDetailService extends BaseReportService<ConceptDetail> {

  public uri = '/api/reportConceptDetail/';

  constructor(injector: Injector) {
    super(injector);
    ////console.log('Instance ReportCurrentEmployeeDataService');
  }

  buildSentence(entity?: ConceptDetail, event?: LazyLoadEvent, extraSearchFields?: ExtraSearchFields): HttpParams {
    if (entity || extraSearchFields) {
      let query = '';
      query = query.concat(
        extraSearchFields && extraSearchFields.fiscalYear ?
          `fiscalYear.id${QueryOperator.Equal}${extraSearchFields.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.executingUnit ?
          `executingUnit.id${QueryOperator.Equal}${extraSearchFields.executingUnit.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.payrollType ?
          `payrollType.id${QueryOperator.Equal}${extraSearchFields.payrollType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.employeeType ?
          `employeeType.id${QueryOperator.Equal}${extraSearchFields.employeeType.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthIni ?
          `month.id${QueryOperator.Equal}${extraSearchFields.monthIni.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );

      query = query.concat(
        extraSearchFields && extraSearchFields.monthIni ?
          `month.id${QueryOperator.Equal}${extraSearchFields.monthFin.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      /*query = query.concat(
        extraSearchFields && extraSearchFields.costCenter ?
          `costCenter.id${QueryOperator.Equal}${extraSearchFields.costCenter.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
*/
      ////console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchToReport(entity?: ConceptDetail, event?: LazyLoadEvent,
    extraSearchFields?: ExtraSearchFields): Observable<ResponsePageable<ConceptDetail>> {
    const url = `${this.rutaServidor}${this.uri}search`;
    this.spinnerService.showAll();
    const httpParams = this.buildSentence(entity, event, extraSearchFields);
    return this.httpClient.get<ResponsePageable<ConceptDetail>>(url, { params: httpParams })
      .pipe(
        tap(response => {
          if (response.numberOfElements > 0) {
            response.content.forEach((value) => {
              // debugger;
              this.convertToDate(value);
            })
          }
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  searchToViewTable(   fiscalYear: any,
    executingUnit: any,
    payrollType: any,
    employeeType: any,
    monthIni: any,
    monthFin: any,
    //costCenter: any,
    object: Vars
    ): Observable<any> {
      const params = new HttpParams()
        .set('fiscalYearId', fiscalYear)
        .set('euId', executingUnit)
        .set('payrollTypeId', payrollType)
        .set('employeeTypeId', employeeType)
        .set('monthIniId', monthIni)
        .set('monthFinId', monthFin)
        //.set('costCenterId', costCenter)
        this.spinnerService.showAll();
        const url = `${this.rutaServidor}${this.uri}search`;
        return this.httpClient.post<any>(url, object, {params}, )
        .pipe(
          tap(response => {
            this.spinnerService.hideAll();
            return response;
          })
       );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/report-concept-detail.service.ts